module.exports = __webpack_public_path__ + "media/images/how-van-2556eb84590026d395532aed9ff8c73d.png";